import type {
  DealOperationsConfirmedParams,
  DealRowActionPayload,
  UseDealOperations,
} from '@openx/components-deal/lib/utils/context/DealHookTypes';
import { useDealsDownload } from '@openx/components-deal/lib/utils/hooks/useDealsDownload';
import { useDealsArchive } from './useDealsArchive';
import { useDealsClone } from './useDealsClone';
import { useDealUpdateStatus } from './useDealUpdateStatus';

export const useDealOperations: UseDealOperations = () => {
  const { pause: pauseDeals, resume: resumeDeals } = useDealUpdateStatus();
  const { archive: deleteDeals } = useDealsArchive();
  const { download: downloadDeals } = useDealsDownload();
  const { clone: cloneDeals } = useDealsClone();

  const onConfirmed = async <T, V extends DealRowActionPayload = DealRowActionPayload>({
    setLoading,
    onFinish,
    deals,
    action,
    actionCallback,
  }: DealOperationsConfirmedParams<T, V>) => {
    try {
      setLoading(action);
      const actionResults = await actionCallback(deals);
      setLoading(null);
      onFinish?.(actionResults);
    } catch {
      setLoading(null);
    }
  };

  return { cloneDeals, deleteDeals, downloadDeals, onConfirmed, pauseDeals, resumeDeals };
};
